export default function () {
	$('.menu__btn').on('click', function () {
		const $btn = $(this);
		const $menuBlock = $btn.closest('.menu');
		const isHeader = $menuBlock.hasClass('header__menu');

		if (isHeader && !$menuBlock.hasClass('menu--inited')) {
			var $mainMenuBlock = $('.menu--main');
			var $catalogClone = $mainMenuBlock.find('.menu__catalog').html();
			var $headerBlock = $menuBlock.closest('.header__with-menu-block');
			var $catalogBlock = $menuBlock.find('.menu__catalog');

			$catalogBlock.append($catalogClone);
			$catalogBlock.css('top', $headerBlock.outerHeight() + 'px');

			$menuBlock.addClass('menu--inited');
		}

		const $menuCatalog = $menuBlock.find('.menu__catalog');

		$btn.toggleClass('js-active');
		$menuCatalog.toggleClass('js-active');

		$menuCatalog.find('.small-banner').each(function () {
			const $banner = $(this);

			if (!$banner.hasClass('lazyloaded')) {
				const imgUrl = $banner.data('bg');
				$banner.css('background-image','url("'+imgUrl+'")');
				$banner.addClass('lazyloaded');
			}
		})
	});

	$('.menu').on('mouseenter', '[data-partial]', function () {
		const partialID = $(this).attr('data-partial');

		$('[data-partial]').not(`[data-partial="${partialID}"]`).removeClass('js-active');
		$(`[data-partial="${partialID}"]`).addClass('js-active');

		$('[data-partial-target]').not(`[data-partial-target="${partialID}"]`).removeClass('js-active');
		$(`[data-partial-target="${partialID}"]`).addClass('js-active');
	});

	$('.e-menu__btn').on('click', function () {
		const $btn = $(this);
		const $menuBlock = $btn.closest('.e-header__block');
		const isHeader = $menuBlock.hasClass('e-header__main');

		if (isHeader && !$menuBlock.hasClass('menu--inited')) {
			var $mainMenuBlock = $('.e-header__block');
			var $catalogClone = $mainMenuBlock.find('.menu__catalog').html();
			var $headerBlock = $menuBlock.closest('.header__with-menu-block');
			var $catalogBlock = $menuBlock.find('.menu__catalog');

			$catalogBlock.append($catalogClone);
			$catalogBlock.css('top', $headerBlock.outerHeight() + 'px');

			$menuBlock.addClass('menu--inited');
		}

		const $menuCatalog = $menuBlock.find('.menu__catalog');

		$btn.toggleClass('js-active');
		$menuCatalog.toggleClass('js-active');

		$menuCatalog.find('.small-banner').each(function () {
			const $banner = $(this);

			if (!$banner.hasClass('lazyloaded')) {
				const imgUrl = $banner.data('bg');
				$banner.css('background-image','url("'+imgUrl+'")');
				$banner.addClass('lazyloaded');
			}
		})
	});

	$('.e-menu__catalog').on('mouseenter', '[data-partial]', function () {
		const partialID = $(this).attr('data-partial');

		$('[data-partial]').not(`[data-partial="${partialID}"]`).removeClass('js-active');
		$(`[data-partial="${partialID}"]`).addClass('js-active');

		$('[data-partial-target]').not(`[data-partial-target="${partialID}"]`).removeClass('js-active');
		$(`[data-partial-target="${partialID}"]`).addClass('js-active');
	});

	$('.e-header__nav-item-dropdown').on('click mouseenter mouseleave', function (e) {

		if (e.type === "click" || e.type === "mouseenter") {
			$(this).addClass('e-header__nav-item-dropdown_active');
		} else if (e.type === "click" || e.type === "mouseleave") {
			$(this).removeClass('e-header__nav-item-dropdown_active');
		}
	});

	$('.e-header__nav-item-dropdown-container').on('click', function (e) {
		e.stopPropagation();
	})
}
